import styled from 'styled-components';

import {
  HERO_FONT_DISPLAY,
  LandingHero,
} from 'constants/landing-hero';

import { sheen } from './keyframes';

const MOBILE = '@media (max-width: 768px)';

export const Wrap = styled.div`
  margin: 0 7.2rem 10.4rem;
  padding: 7.2rem 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.4rem;
  text-align: center;
  border-radius: 3.2rem;
  background: ${LandingHero.band.bg};
  border: 0.1rem solid ${LandingHero.band.border};
  box-shadow:
    0 3rem 6rem -3rem ${LandingHero.band.shadow},
    inset 0 0.1rem 0 ${LandingHero.cardInsetHighlight};
  backdrop-filter: blur(1.6rem);
  -webkit-backdrop-filter: blur(1.6rem);

  ${MOBILE} {
    margin: 0 2.4rem 6.4rem;
    padding: 4.8rem 2.4rem;
  }
`;

export const Title = styled.div`
  font-family: ${HERO_FONT_DISPLAY};
  font-weight: 800;
  font-size: 3.4rem;
  line-height: 1.08;
  letter-spacing: -0.12rem;
  max-width: 86rem;
  color: ${LandingHero.textPrimary};

  ${MOBILE} {
    font-size: 2.4rem;
  }
`;

export const Subtitle = styled.div`
  font-size: 1.6rem;
  line-height: 1.6;
  color: ${LandingHero.textMuted};
  max-width: 60rem;
`;

export const Cta = styled.button<{ $tone: 'green' | 'ink' }>`
  position: relative;
  overflow: hidden;
  margin-top: 0.8rem;
  background: ${({ $tone }) =>
    $tone === 'green' ? LandingHero.ctaGradient : LandingHero.skyCtaGradient};
  color: ${({ $tone }) =>
    $tone === 'green' ? LandingHero.ctaText : LandingHero.skyCtaText};
  font-size: 1.6rem;
  font-weight: 800;
  padding: 1.8rem 3.6rem;
  border-radius: 1.6rem;
  border: none;
  cursor: pointer;
  font-family: inherit;
  box-shadow:
    0 1.4rem 3.4rem -1rem
      ${({ $tone }) =>
        $tone === 'green' ? LandingHero.ctaShadow : LandingHero.skyCtaShadow},
    inset 0 0.1rem 0 ${LandingHero.ctaInsetHighlight};
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 40%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      ${LandingHero.ctaSheen},
      transparent
    );
    animation: ${sheen} 3.6s ease-in-out infinite;
  }

  &:hover {
    transform: translateY(-0.2rem);
  }

  @media (prefers-reduced-motion: reduce) {
    &::after {
      animation: none;
    }
  }
`;
